import { create } from "zustand";
type Theme="dark"|"light";
const KEY="axon-tags.theme";
const read=():Theme=>{ try{return(localStorage.getItem(KEY) as Theme)||"dark"}catch{return"dark"} };
const apply=(t:Theme)=>document.documentElement.setAttribute("data-theme",t);
interface S{theme:Theme;toggleTheme:()=>void;}
export const useUiStore=create<S>((set,get)=>{
  apply(read());
  return{theme:read(),toggleTheme:()=>{
    const next:Theme=get().theme==="dark"?"light":"dark";
    try{localStorage.setItem(KEY,next)}catch{/**/}
    apply(next);set({theme:next});
  }};
});
